const scrollToNextButton = document.getElementById('scrollToNextSection');

if (scrollToNextButton) {
    scrollToNextButton.addEventListener('click', () => {
        const collectionContent = document.getElementById('js-collection-content');
        
        if (collectionContent) {
            collectionContent.scrollIntoView({ behavior: 'smooth' });
        }
    });
}